import { render, staticRenderFns } from "./IntegralGoodsList.vue?vue&type=template&id=7599c118&scoped=true&"
import script from "./IntegralGoodsList.vue?vue&type=script&lang=js&"
export * from "./IntegralGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./IntegralGoodsList.vue?vue&type=style&index=0&id=7599c118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599c118",
  null
  
)

export default component.exports